import { getAnalytics } from "@tm/insurance/analytics";
import { navigationActions } from "@tm/insurance/navigation";
import {
  AnchorTag,
  FlexComp,
  FormattedText,
  ImageComponent,
  LandingButton,
} from "@tm/static";
import { TextNodeType } from "../FormattedText/FormattedText";
import {
  InfoText,
  ManageInsuranceStyle,
  TitleText,
} from "./ManageInsurance.style";
interface manageInsProp {
  title?: TextNodeType;
  info?: TextNodeType;
  orderBtn?: string;
  handleManageOrder?: () => void;
  goHomeText?: string | TextNodeType;
  orderBtnIcon?: string;
  goHomeBtnIcon?: string;
}

const ManageInsurance = ({
  title,
  info,
  orderBtn,
  handleManageOrder,
  goHomeText,
  orderBtnIcon,
  goHomeBtnIcon,
}: manageInsProp) => {
  const analytics = getAnalytics();
  const gotoHome = () => {
    analytics?.trackThankYouEvents({
      pageName: "THANK_YOU_POLICY",
      actionType: "go_home_clicked",
    });
    navigationActions.navigateToLanding({ type: "" });
    // navigationActions.navigateToRouteNameWithHostname(
    //   ROUTE_CONSTANTS.COMMON_LANDING,
    //   { type: "" }
    // );
    //TODO: aDD This once we have the common landing page for seo
  };

  return (
    <ManageInsuranceStyle>
      <ImageComponent
        width={"104px"}
        height={"104px"}
        src="https://tripmoneycmsimgak.mmtcdn.com/img/manage_Ins_Bg_410326bba8.svg"
      />
      <TitleText>
        <FormattedText value={title} />
      </TitleText>
      {info && (
        <InfoText>
          <FormattedText value={info} />
        </InfoText>
      )}
      <LandingButton
        btnRightIcon={orderBtnIcon}
        customWidth="100%"
        customTitle={orderBtn}
        onClick={handleManageOrder}
      />
      {/* CB */}
      {goHomeText && (
        <FlexComp
          margin="16px 0 0"
          isCursorPointer
          alignItems="center"
          gap="4px"
          handleClick={gotoHome}
        >
          <AnchorTag
            textTransform="uppercase"
            fontSize="xs"
            fontWeight="black"
            color="var(--tm-accent-color)"
          >
            <FormattedText value={goHomeText} />
          </AnchorTag>
          <ImageComponent width="16px" height="16px" src={goHomeBtnIcon} />
        </FlexComp>
      )}
    </ManageInsuranceStyle>
  );
};

export default ManageInsurance;
